module.exports = __webpack_public_path__ + "img/carousel03.35508868.webp";